import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import enTranslation from './en'
import esTranslation from './es'

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enTranslation },
    es: { translation: esTranslation },
  },
  lng: 'es',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
  pluralSeparator: '_',
  contextSeparator: '_',
  compatibilityJSON: 'v3',
})

export default i18n
